var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    stroke: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8946 29V23.7982H25.6636L25.9284 21.576H23.8945V20.1573C23.8945 19.514 24.0597 19.0755 24.9124 19.0755L26 19.075V17.0876C25.8119 17.0605 25.1662 17 24.4152 17C22.8471 17 21.7735 18.0355 21.7735 19.9373V21.576H20V23.7982H21.7735V28.9999L23.8946 29Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9ba2d7c80b5b8f2c197cf5f2d0286fd6.svg";
export { ForwardRef as ReactComponent };